import React from 'react';
import { Progress } from 'antd';
import { UserReport } from '@services/userreport/types';

type Props = { report: UserReport };

const ReportExportProgress = ({ report }: Props) => (
  report.state === 'processing'
    ? <Progress percent={report.progressPercentage || 0} size="small" />
    : null
);

export default ReportExportProgress;
